import * as React from 'react'
import { CopyEditorService } from './copyEditorService'

export const CopyEditorServiceContext = React.createContext(null as any as CopyEditorService)
